<template>
    <nav
      class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white"
      :class="{ 'sidebar-collapsed': $sidebar.isMinimized }"
      id="sidenav-main"
    >
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="navbar-brand pb-0" :title="$sidebar.isMinimized ? 'BXI' : null" to="/landing_page">
                <img src='@/assets/barter-full.png' alt='logobarter'>
                <br>
                <small class="sidebar-brand-label" :class="textColor" v-if="accountTemplateName != ''">{{ accountTemplateName.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}} </small>
                <!-- <img :src="logo" class="navbar-brand-img" alt="..."> -->
            </router-link>

            <!-- <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>

            <div class="row navbar-brand" >
              <span class="">BXI</span>
            </div> -->
            
            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                    <base-dropdown class="nav-item" position="left">
                        <a slot="title" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                              <span class="avatar avatar-sm rounded-circle">
                                <img v-if="accountLogo" alt="Account logo" :src="accountLogo">
                                <span v-else class="avatar-initials">{{ accountInitial }}</span>
                              </span>
                            </div>
                        </a>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">USER SETTINGS</h6>
                        </div>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-settings-gear-65"></i>
                            <span>Change Password</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Activity</span>
                        </router-link>

                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">SERVER SETTINGS</h6>
                        </div>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-settings-gear-65"></i>
                            <span>Change Password</span>
                        </router-link>

                        <div class="dropdown-divider"></div>
                        <a href="#!" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Logout</span>
                        </a>
                    </base-dropdown>
                </ul>
            </slot>
            <slot></slot>

            <div class="sidebar-toolbar d-none d-md-flex">
              <button
                type="button"
                class="btn btn-link sidebar-collapse-button"
                :class="{ 'sidebar-collapse-button-collapsed': $sidebar.isMinimized }"
                :title="$sidebar.isMinimized ? 'Expand sidebar' : 'Collapse sidebar'"
                @click.prevent="$sidebar.toggleMinimize()"
              >
                <i :class="$sidebar.isMinimized ? 'fa fa-angle-double-right' : 'fa fa-angle-double-left'"></i>
                <span v-if="!$sidebar.isMinimized" class="ml-2">COLLAPSE SIDEBAR</span>
              </button>
            </div>

            <div class="navbar-collapse collapse" :class="{ show: shouldShowSidebarContent }" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                 <h1>BXI</h1>
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul v-if="$slots.links" class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>

                <div v-if="developerMode != true">
                  <!--  INSERT LOOP HERE -->
                  <div v-if="!isRippleAdmin && !$sidebar.isMinimized">
                    <div v-for="category in backOfficeCategories" :key="category.id">
                      <hr class="my-3">
                      <h6 :data-testid="`category-${toSlug(category.name)}`" class="navbar-heading text-muted sidebar-header" v-b-toggle="'collapse' + category.id">
                        <span class="sidebar-heading-label">{{ category.name }}</span>
                        <i class="fa fa-chevron-right open-menu-icon collapse-icon "></i>
                        <i class="fa fa-chevron-down close-menu-icon collapse-icon"></i>
                      </h6>
                      <b-collapse :id="'collapse' + category.id">
                        <ul class="navbar-nav mb-md-3">
                          <div v-for="subCateg in category.raw_children" :key="subCateg.id">
                            <!-- <div v-if="subCateg.code == 'MW-002'">
                              <sidebar-item :key="subCateg.id" :link="{name: subCateg.name, icon: subCateg.icon, path: subCateg.endpoint}" />
                            </div> -->
                            <div v-if="subCateg.code == 'MW-001'">
                              <div v-if="isAccountOwner == true">
                                <sidebar-item v-if="subCateg.name != 'Ripple Admin'" :key="subCateg.id" :link="{name: subCateg.name, icon: subCateg.icon, path: subCateg.endpoint}" />
                              </div>
                              <table v-if='myWavelets.length > 0' class="table table-borderless ml-4 mt-2" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                                <tbody>
                                  <tr v-for='w in myWavelets' :key="w.id">
                                    <td class="p-0 pb-3">
                                      <img v-if='w.configuration.logo' :src="w.configuration.logo" width="20vh" height="20vh">
                                      <i v-else class="fas fa-wave-square text"></i>
                                      <a class='ml-3' add target="_blank" style="text-decoration: none; color:#000000; opacity: 0.5; font-size: 0.9rem;" :href='w.sidebar_redirect_link'>{{w.wavelet_name}}</a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-else>
                              <sidebar-item v-if="subCateg.name != 'Ripple Admin'" :key="subCateg.id" :link="{name: subCateg.name, icon: subCateg.icon, path: subCateg.endpoint}" />
                            </div>
                          </div>
                        </ul>
                      </b-collapse>
                    </div>
                    <div> 
                      <hr class="my-3">
                      <h6 id="category-product-support" class="navbar-heading text-muted sidebar-header" v-b-toggle="'collapseSupport1'">
                        <span class="sidebar-heading-label">Product Support</span>
                        <i class="fa fa-chevron-right open-menu-icon collapse-icon "></i>
                        <i class="fa fa-chevron-down close-menu-icon collapse-icon"></i>
                      </h6>
                      <b-collapse :id="'collapseSupport1'">
                        <ul class="navbar-nav mb-md-3">
                          <li class="nav-item">
                            <a data-testid="module-whats-new" href="https://iripple.gitbook.io/bxi-release-notes" class="nav-link" target="_blank">
                              <i class="fa fa-lightbulb text-info"></i>
                              <span class="nav-link-text">What's New</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a data-testid="module-rms-docs" href="https://iripple.gitbook.io/barter-products-user-guide-library/barter-retail-management-system-user-guide" class="nav-link" target="_blank">
                              <i class="fa fa-book text-info"></i>
                              <span class="nav-link-text">BXI RMS Docs</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a data-testid="module-pos-docs" href="https://iripple.gitbook.io/barter-products-user-guide-library/barter-5-pos-user-guide" class="nav-link" target="_blank">
                              <i class="fa fa-book text-info"></i>
                              <span class="nav-link-text">BXI C# POS Docs</span>
                            </a>
                          </li>
                        </ul>
                      </b-collapse>
                    </div>

                    <!-- <div v-if='myWavelets.length > 0'> -->
                      <!-- <hr class="my-3">
                      <div>
                        <h6 class="navbar-heading text-muted pb-3">MY WAVELETS</h6>
                        <div v-if="(isAccountOwner == true)">
                            <ul class="navbar-nav mb-md-3">
                              <sidebar-item :link="{name: 'BXI Wavelets', 'icon': 'fas fa-wave-square text-blue', path: '/wavelets'}" />
                            </ul>
                        </div>
                        <table v-if='myWavelets.length > 0' class="table table-borderless" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                          <tbody>
                            <tr v-for='w in myWavelets' :key="w.id">
                              <td class="p-0 pb-3">
                                <img v-if='w.configuration.logo' :src="w.configuration.logo" width="20vh" height="20vh">
                                <i v-else class="fas fa-wave-square text"></i>
                                <a class='ml-3' add target="_blank" style="text-decoration: none; color:#000000; opacity: 0.5; font-size: 0.9rem;" :href='w.sidebar_redirect_link'>{{w.wavelet_name}}</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div> -->
                    <!-- </div> -->

                    <!-- <div v-if='myApps.length > 0'> -->
                    <!-- <hr class="my-3">
                    <div>
                      <h6 class="navbar-heading text-muted pb-3">MY APPS</h6>
                      <div v-if="(isAccountOwner == true)">
                          <ul class="navbar-nav mb-md-3">
                            <sidebar-item :link="{name: 'Devices', 'icon': 'fas fa-tablet-alt text-blue', path: '/devices'}" />
                            <sidebar-item :link="{name: 'BXI Apps', 'icon': 'fas fa-mobile-alt text-blue', path: '/apps'}" />
                          </ul>
                      </div>
                    </div> -->
                    <!-- </div> -->

                  </div>
                  <div v-else-if="!isRippleAdmin && $sidebar.isMinimized">
                    <ul class="navbar-nav mb-md-3">
                      <div v-for="link in collapsedSidebarLinks" :key="`collapsed-${link.name}-${link.path}`">
                        <sidebar-item :link="link" />
                      </div>
                      <li v-for="link in supportLinks" :key="`support-${link.name}`" class="nav-item">
                        <a
                          class="nav-link nav-link-collapsed"
                          :href="link.path"
                          :title="link.name"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i :class="link.icon"></i>
                          <span class="nav-link-text">{{ link.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div v-else-if="!isRippleAdmin && $sidebar.isMinimized">
                    <ul class="navbar-nav mb-md-3">
                      <div v-for="link in collapsedSidebarLinks" :key="`collapsed-${link.name}-${link.path}`">
                        <sidebar-item :link="link" />
                      </div>
                      <li v-for="link in supportLinks" :key="`support-${link.name}`" class="nav-item">
                        <a
                          class="nav-link nav-link-collapsed"
                          :href="link.path"
                          :title="link.name"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i :class="link.icon"></i>
                          <span class="nav-link-text">{{ link.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div v-else>
                      <h6 class="navbar-heading text-muted">ADMINISTRATION</h6>
                      <ul class="navbar-nav mb-md-3">
                          <div v-for="link in iRippleAdminLinks" :key="link.name">
                              <sidebar-item :link="link" />
                          </div>
                      </ul>
                  </div>
                </div>
                <!-- DEVELOPER MODE -->
                <div v-else>
                  <hr class="my-3">
                    <h6 class="navbar-heading text-muted">ADMINISTRATION</h6>
                    <ul class="navbar-nav mb-md-3">
                        <div>
                            <sidebar-item :link="{name: 'Wavelets', icon: 'fas fa-wave-square text-red', path: '/wavelets'}" />
                        </div>
                    </ul>
                </div>

            </div>
            <!-- <div> 
              <h5 class=" text-muted">Product Support:</h5>
              <ul class="mb-md-3 h5">
                <a href="https://iripple.gitbook.io/bxi-release-notes" class="font-weight-bold text-muted" target="_blank">What's New</a><br>
                <a href="https://iripple.gitbook.io/barter-products-user-guide-library/barter-retail-management-system-user-guide" class="font-weight-bold text-muted" target="_blank">BXI RMS Docs</a><br>
                <a href="https://iripple.gitbook.io/barter-products-user-guide-library/barter-5-pos-user-guide" class="font-weight-bold text-muted" target="_blank">BXI C# POS Docs</a>
              </ul>
            </div> -->
          </div>
    </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'
  import HTTPRequest from '../../controllers/httpRequest.js'
  import { mapState } from 'vuex'
  import secureStorage from '../../controllers/secureStorage';

  export default {
    name: 'sidebar',
    components: {
      NavbarToggleButton
    },
    props: {
      logo: {
        type: String,
        default: 'img/brand/green.png',
        description: 'Sidebar app logo'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    data: function () {
      return {
        iRippleAdminLinks: [
          { name: 'Admin Users', icon: 'ni ni-laptop text-red', path: '/admin_users' },
          { name: 'Internal Admin', icon: 'ni ni-compass-04 text-red', path: '/internal_admin' },
          { name: 'Developers', icon: 'fas fa-user-astronaut text-red', path: '/developer_accounts' },
          { name: 'POS Updater', icon: 'fas fa-cogs text-red', path: '/pos_updater' },
          { name: 'POS Updater v2', icon: 'fas fa-cogs text-red', path: '/pos_updater_v2' },
          { name: 'Release Manager', icon: 'fas fa-refresh text-red', path: '/release_manager' },
          { name: 'Admin Logs', icon: 'ni ni-paper-diploma text-red', path: '/admin_logs' }
        ],
        backOfficeCategories: this.enabledCategories,
        userName: secureStorage.getItem("userName"),
        accountLogo: secureStorage.getItem("account_logo"),
        accountName: secureStorage.getItem("accountName"),
        isRippleAdmin: secureStorage.getItem("isRippleAdmin"),
        isAccountOwner: secureStorage.getItem("isAccountOwner"),
        developerMode: secureStorage.getItem("developerMode"),
        myWavelets: [],
        myApps: [],
        accountTemplateName: '',
        businessTypeCode: JSON.parse(localStorage.getItem("businessTypeCode")),
        windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
      }
    },
    mounted: async function(){
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.handleResize);
      }
      if (this.developerMode != true) {
        //Get My Accessible Wavelets
        var my_wavelets = await HTTPRequest.getRequest(this.endPoint + 'account_web_wavelets/get_sidebard_wavelets', null)
        this.myWavelets = my_wavelets

        //Get My Accessible Apps
        // var my_apps = await HTTPRequest.getRequest(this.endPoint + 'account_app_wavelets/get_sidebar_wavelets', null)
        // this.myApps = my_apps
      }
      if(secureStorage.getItem("accountTemplateName") != null && secureStorage.getItem("accountTemplateName") != '') {
        this.accountTemplateName = secureStorage.getItem("accountTemplateName")
      }
      this.backOfficeCategories = this.enabledCategories;
    },

    computed: {
      ...mapState(['endPoint', 'serverType', 'enabledCategories', 'enabledCategoryUrls']),
        accountInitial() {
          return this.accountName ? this.accountName.charAt(0).toUpperCase() : '?';
        },
        shouldShowSidebarContent() {
        if (this.windowWidth >= 768) {
          return true;
        }

        return this.$sidebar.showSidebar;
      },
      supportLinks() {
        return [
          {
            name: "What's New",
            icon: 'fa fa-lightbulb text-info',
            path: 'https://iripple.gitbook.io/bxi-release-notes'
          },
          {
            name: 'BXI RMS Docs',
            icon: 'fa fa-book text-info',
            path: 'https://iripple.gitbook.io/barter-products-user-guide-library/barter-retail-management-system-user-guide'
          },
          {
            name: 'BXI C# POS Docs',
            icon: 'fa fa-book text-info',
            path: 'https://iripple.gitbook.io/barter-products-user-guide-library/barter-5-pos-user-guide'
          }
        ];
      },
      collapsedSidebarLinks() {
        if (this.isRippleAdmin) {
          return this.iRippleAdminLinks;
        }

        if (this.developerMode == true) {
          return [
            { name: 'Wavelets', icon: 'fas fa-wave-square text-red', path: '/wavelets' }
          ];
        }

        const links = [];

        this.backOfficeCategories.forEach((category) => {
          (category.raw_children || []).forEach((subCateg) => {
            if (subCateg.name === 'Ripple Admin') {
              return;
            }

            if (subCateg.code === 'MW-001' && this.isAccountOwner != true) {
              return;
            }

            links.push({
              name: subCateg.name,
              icon: subCateg.icon,
              path: subCateg.endpoint
            });
          });
        });

        return links;
      },
      textColor() {
        if (this.businessTypeCode == "SUP") {
          return "text-sup";
        }
        else if (this.businessTypeCode == "FNB") {
          return "text-fnb";
        }
        else if (this.businessTypeCode == "BOU") {
          return "text-bou";
        }
        else if (this.businessTypeCode == "DRU") {
          return "text-dru";
        }
        else if (this.businessTypeCode == "HIM") {
          return "text-him";
        }
        return "";
    }
    },

    watch: {
      enabledCategories() {
        this.backOfficeCategories = this.enabledCategories;
      }
    },

    methods: {
      handleResize() {
        this.windowWidth = window.innerWidth;
      },
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      },
      // async getRawChildren(id) {
      //   var backofficeCategoriesRequest = await HTTPRequest.getRequest(this.endPoint + 'system_module_categories?status=A&parent_id=' + id, null)
      //   return backofficeCategoriesRequest
      // }
        toSlug(str) {
        return str
          .toLowerCase()          // make all letters lowercase
          .trim()                 // remove leading/trailing spaces
          .replace(/\s+/g, '-')    // replace spaces with dashes
          .replace(/[^a-z0-9-]/g, ''); // remove any non-alphanumeric except dashes
      }
    },

    beforeDestroy() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.handleResize);
      }

      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>

<style scoped>
  .avatar-initials {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: #5e72e4;
    color: #ffffff;
    font-weight: 600;
    font-size: 0.875rem;
    text-transform: uppercase;
  }

  .sidebar-header{
    cursor: pointer;
  }

  .nav-link-collapsed {
    justify-content: center;
  }

  .nav-link-collapsed > i {
    min-width: 0;
    margin-right: 0;
  }

  .nav-link-collapsed .nav-link-text {
    display: none;
  }

  .sidebar-toolbar {
    padding: 0.5rem 0 0;
  }

  .sidebar-collapse-button {
    width: 100%;
    color: #8898aa !important;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.25rem 0;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: .04em;
    text-transform: uppercase;
    line-height: 1.5;
    text-decoration: none;
  }

  .sidebar-collapse-button:hover,
  .sidebar-collapse-button:focus {
    color: #8898aa !important;
    text-decoration: none;
  }

  .sidebar-collapse-button-collapsed {
    justify-content: center;
  }

  .sidebar-toolbar + .navbar-collapse > .navbar-nav:first-child,
  .sidebar-toolbar + .navbar-collapse > div:first-child > div:first-child > hr.my-3,
  .sidebar-toolbar + .navbar-collapse > div:first-child > hr.my-3 {
    margin-top: 0 !important;
  }

  .collapse-icon{
    float: right;
  }

  .collapsed > .close-menu-icon,
  :not(.collapsed) > .open-menu-icon {
    display: none;
  }
  @media (min-width:801px)  {
    /* #sidenav-main::-webkit-scrollbar {
      display: none;
    } */

    .container-fluid {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
    }

    #sidenav-main {
      /* -ms-overflow-style: none;  IE and Edge */
      /* scrollbar-width: none;  Firefox */
      width: 300px;
      max-width: 300px;
      overflow: hidden;
      transition: width 0.2s ease, max-width 0.2s ease, padding 0.2s ease;
    }

    #sidenav-collapse-main {
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 1rem;
    }

    #sidenav-collapse-main::before {
      display: none;
      content: none;
      margin: 0;
    }

    #sidenav-main.sidebar-collapsed {
      width: 80px;
      max-width: 80px;
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }

    #sidenav-main.sidebar-collapsed .navbar-brand {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 0;
      padding-right: 0;
    }

    #sidenav-main.sidebar-collapsed .navbar-brand > img {
      max-width: 42px;
      max-height: 42px;
      object-fit: contain;
    }

    #sidenav-main.sidebar-collapsed .sidebar-brand-label,
    #sidenav-main.sidebar-collapsed .navbar-heading,
    #sidenav-main.sidebar-collapsed .collapse-icon,
    #sidenav-main.sidebar-collapsed br {
      display: none;
    }

    #sidenav-main.sidebar-collapsed .sidebar-toolbar {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
  }

  li.text-sup::marker,
.text-sup {
  color: #297BF3;
  font-size: 6;
}

li.text-fnb::marker,
.text-fnb {
  color: #F0653A;
  font-size: 6;
}

li.text-bou::marker,
.text-bou {
  color: #6636DD;
  font-size: 6;
}

li.text-dru::marker,
.text-dru {
  color: #56CFCB;
  font-size: 6;
}

li.text-him::marker,
.text-him {
  color: #E93559;
  font-size: 6;
}

</style>
